import http from "../jslibs/axios/http";

// 教师列表
export const getTeacherList = (data) => http.get("/v1/cms/teacher", data);
// 教师详情
export const getTeacherDetail = (uuid) => http.get(`/v1/cms/teacher/${uuid}`);
// 新增教师
export const addTeacher = (data) => http.post(`/v1/cms/teacher`, data);
// 编辑教师
export const editTeacher = (data, uuid) => http.put(`/v1/cms/teacher/${uuid}`, data);
// 查看详情
export const teacherDetail = (uuid) => http.get(`/v1/cms/teacher/${uuid}`);
// 删除教师
export const deleteTeacher = (uuid) => http.delete(`/v1/cms/teacher/${uuid}`);
// 导出教师列表
export const exportTeacher = (data) => http.down("/v1/cms/TeacherImport", data);
// 教师日程
export const teacherSche = (data) => http.get(`/v1/cms/CourseMonth`, data);
